/* import __COLOCATED_TEMPLATE__ from './installation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();